import React from "react";

export const LazyFeedSelectionControlBridge = React.lazy(
    () =>
        import(
            /* webpackChunkName: "CasePageInserts" */ "./FeedSelectionControl"
        )
);

export const LazyCaseResultsSummaryBridge = React.lazy(
    () =>
        import(/* webpackChunkName: "CasePageInserts" */ "./CaseResultsSummary")
);

export const LazyCaseLogExpand = React.lazy(() =>
    import(
        /* webpackChunkName: "CasePageInserts" */ "./caseLog/ExpandPopup"
    ).then(x => ({ default: x.ExpandPopup }))
);

export const LazyCaseLogList = React.lazy(() =>
    import(/* webpackChunkName: "CasePageInserts" */ "./caseLog/List").then(
        x => ({ default: x.List })
    )
);

export const LazyOwnershipControl = React.lazy(() =>
    import(/* webpackChunkName: "CasePageInserts" */ "./OwnershipControl").then(
        x => ({ default: x.OwnershipControl })
    )
);
